import { ToggleButton, Tooltip } from '@mui/material';
import { useStore } from 'store/store.ts';
import { LOG_LEVELS, LogLevel } from './logLevels.ts';
import { logLevelFilterButtonStyle } from './LogLevelFilter.styles.ts';

const LogLevelFilter = () => {
  const enabledLogLevels = useStore.use.enabledLogLevels();
  const setEnabledLogLevels = useStore.use.setEnabledLogLevels();

  const toggleLevel = (level: LogLevel) =>
    setEnabledLogLevels(
      enabledLogLevels.includes(level)
        ? enabledLogLevels.filter((enabled) => enabled !== level)
        : [...enabledLogLevels, level],
    );

  return (
    <Tooltip title="Choose which log levels to display">
      <div role="group" aria-label="log level filter" className="flex items-center gap-1">
        {LOG_LEVELS.map((level) => (
          <ToggleButton
            key={level}
            value={level}
            selected={enabledLogLevels.includes(level)}
            onChange={() => toggleLevel(level)}
            size="small"
            aria-label={level}
            sx={logLevelFilterButtonStyle(level)}
          >
            {level}
          </ToggleButton>
        ))}
      </div>
    </Tooltip>
  );
};

export default LogLevelFilter;
